import {useRelayProvisioning, useRelayReportedError, useTaskStartup} from '../../../ahp/use-relay-provisioning'
import type {TaskStartup} from '../../../ahp/task-startup-store'
import type {ProvisioningStatus} from '@github-ui/ahp-relay/session-host/resolve-project'

interface TaskStartupTimelineState {
  taskStartup: TaskStartup | undefined
  cloneProgress: number | undefined
  provisioningMessage: string | undefined
  reportedError: string | undefined
  provisioning: ProvisioningStatus | undefined
}

export function useTaskStartupTimeline(taskId: string | undefined): TaskStartupTimelineState {
  const provisioning = useRelayProvisioning(taskId)
  const taskStartup = useTaskStartup(taskId)
  const reportedError = useRelayReportedError(taskId)

  const reportedCloneProgress = provisioning?.phase === 'cloning' ? provisioning.progress : undefined
  const cloneProgress =
    reportedCloneProgress !== undefined && Number.isFinite(reportedCloneProgress)
      ? Math.min(100, Math.max(0, Math.round(reportedCloneProgress)))
      : undefined

  let provisioningMessage: string | undefined
  switch (provisioning?.phase) {
    case 'cloning':
      provisioningMessage = 'Cloning repository…'
      break
    case 'preparing':
      provisioningMessage = 'Preparing repository…'
      break
  }

  return {taskStartup, cloneProgress, provisioningMessage, reportedError, provisioning}
}
